import { QueryClient } from '@tanstack/react-query'

/**
 * Defaults tuned for mobile / high-latency networks:
 * - Long staleTime reduces duplicate requests when navigating back to a page.
 * - refetchOnWindowFocus off avoids RTT spikes when switching apps on phones.
 * - Single retry limits thundering herd on flaky 4G.
 */
export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
